import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";

const Header = ({ extraComponent = null, pictureUrl }: { extraComponent?: any, pictureUrl?: string }) => {
	const param = useParams();
	const location = useLocation()
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', handleResize);
	}, []);
	return (
		<div className='header-wrapper'>                        
			<div className="header-container d-none d-md-block">
			<p className='header-logo-tittle'>
				<img
					className='homepage-icon'
					// src='/assets/icon-black.png'
					// src='/assets/130*130.png'
					alt='search bubble logo'
					style={{ width: isMobile ? "32px" : "150px" }}
					src={isMobile ? "/assets/Logo-Black.svg" : "/assets/Wordmark-Logo-Black.svg"}
				/>
			</p>
			</div>
			{extraComponent}
		</div>
	);
};

export default Header;
